import { formatDate } from "@/Utils/helper";

import TableFirmSettings from "../../common/table-firm-settings";

const tableHeadingStyle = { fontSize: "14px", fontWeight: "bold" };

const ESignatureTemplates = ({ templates, onEdit }) => (
  <TableFirmSettings>
    <thead>
      <tr>
        <th className="td-autosize" style={{ minWidth: "25px", width: "25px", maxWidth: "25px" }} />
        <th className="td-autosize text-center" style={tableHeadingStyle}>
          Template Name
        </th>
        <th
          style={{
            minWidth: "15px",
            width: "15px",
            maxWidth: "15px",
          }}
        />
        <th className="td-autosize text-center" style={tableHeadingStyle}>
          File Name
        </th>
        <th
          style={{
            minWidth: "10px",
          }}
        />
        <th
          className="td-autosize text-center"
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            minWidth: "500px",
            maxWidth: "500px",
          }}
        >
          Case Types
        </th>
        <th
          style={{
            minWidth: "10px",
          }}
        />
        <th
          className="td-autosize text-center"
          style={{
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Created At
        </th>
        <th
          style={{
            minWidth: "10px",
            maxWidth: "10px",
            width: "10px",
          }}
        />
      </tr>
    </thead>
    <tbody>
      {templates?.map((template, index) => (
        <tr key={template.id ?? `${template.name}-${index}`} style={{ height: "25px" }}>
          <td style={{ fontSize: "14px", color: "var(--primary-25)", fontWeight: "600" }}>
            {index + 1}
          </td>
          <td className="text-start" style={{ fontSize: "14px" }}>
            {template.name}
          </td>
          <td />
          <td className="text-start" style={{ fontSize: "14px" }}>
            {template.document?.fileName}
          </td>
          <td />
          <td className="text-center" style={{ fontSize: "14px" }}>
            <div
              className="d-flex flex-row flex-wrap m-t-5 m-b-5 align-items-start justify-content-center"
              style={{ gap: "5px", width: "100%" }}
            >
              {template?.caseTypes?.map((caseType) => (
                <div
                  key={caseType.id}
                  className="badge  height-21 d-flex align-items-center"
                  style={{ gap: "5px", background: "var(--primary-80)", color: "white" }}
                >
                  {caseType.icon ? (
                    <div className="ic ic-15">
                      <img src={caseType.icon} alt={`${caseType.name} icon`} className="ic-15" />
                    </div>
                  ) : (
                    <div style={{ marginRight: "15px" }} />
                  )}
                  <span>{caseType.name}</span>
                </div>
              ))}
            </div>
          </td>
          <td />
          <td className="text-center" style={{ fontSize: "14px" }}>
            <div
              className="d-flex justify-content-center space-x-5 gap-1"
              style={{
                fontWeight: "600",
              }}
            >
              {formatDate(template?.createdAt)}
              <button
                type="button"
                className="height-20 btn d-flex align-items-center btn-success-hover-green-templates justify-content-center"
                style={{ background: "var(--primary-25)", color: "var(--primary)" }}
                onClick={() => onEdit(template)}
              >
                <span>Edit</span>
                <span>
                  <i
                    style={{ position: "relative", top: "1px" }}
                    className="ic ic-15 edit-template-icon ms-1"
                  />
                </span>
              </button>
            </div>
          </td>
          <td />
        </tr>
      ))}
    </tbody>
  </TableFirmSettings>
);

export default ESignatureTemplates;

{
  /* <td>
              <div className="d-flex justify-content-center space-x-5">
                <button
                  type="button"
                  className="height-20 btn d-flex align-items-center btn-success-hover-green-templates justify-content-center"
                  style={{ background: "var(--primary-25)", color: "var(--primary)" }}
                  onClick={() => onEdit(template)}
                >
                  <span>Edit</span>
                  <span>
                    <i
                      style={{ position: "relative", top: "1px" }}
                      className="ic ic-15 edit-template-icon ms-1"
                    />
                  </span>
                </button>
              </div>
            </td> */
}
